import firebase from 'firebase';

var firebaseConfig = {
    apiKey: "AIzaSyD3DFA3QlgCXEYxJs2VXh4yV3hU1HFFk1o",
    authDomain: "ummeed-89d02.firebaseapp.com",
    projectId: "ummeed-89d02",
    storageBucket: "ummeed-89d02.appspot.com",
    messagingSenderId: "508946281458",
    appId: "1:508946281458:web:6f4599aa19c5684f6cf16b"
};
const fire = firebase.initializeApp(firebaseConfig);
export default fire;